import { useTranslate } from "ra-core";

import { MobileSettingsBody } from "../settings/SettingsPageMobile";
import { morphTriggerSelector } from "./closeButtonPlacement";
import { useMobileChrome } from "./MobileChrome";
import { useMobileWindowState } from "./MobileWindowState";
import { MorphWindow } from "./MorphWindow";

/**
 * Mobile account and settings, a full-screen liquid-glass window grown from
 * the top-bar avatar; its close button sits on the avatar. It survives a
 * language change made inside it (open, scrolled where it was).
 */
export const UserSettingsSheet = () => {
  const translate = useTranslate();
  const { activeWindow, closeWindow } = useMobileChrome();
  const { scrollTop } = useMobileWindowState();

  return (
    <MorphWindow
      open={activeWindow === "account"}
      onClose={closeWindow}
      trigger={morphTriggerSelector("account")}
      title={translate("crm.mobile.settings_title")}
      closeLabel={translate("crm.mobile.close_settings")}
      testId="mobile-account-sheet"
      keptScroll={scrollTop}
    >
      <MobileSettingsBody />
    </MorphWindow>
  );
};
